module.exports = __webpack_public_path__ + "img/hr-tree-07-c-trunk.ab5ae4cb.png";